import Democracity from './democracity';

const democracityRoutes = [
  { path: 'democracity', element: <Democracity /> },
];

export default democracityRoutes;
